import MessageInputBar from "./MessageInputBar";
import ConversationHeader from "./ConversationHeader";
import MessagesList from "./MessagesList";

export default function DesktopConversation({
  counterpartyId,
  isSelected,
}: {
  counterpartyId: string;
  isSelected: boolean;
}) {
  return (
    <div className="flex flex-col h-[85vh]">
      <ConversationHeader counterpartyId={counterpartyId} />
      <MessagesList counterpartyId={counterpartyId} enabled={isSelected} />
      <MessageInputBar counterpartyId={counterpartyId} />
    </div>
  );
}
